import Axios from "@/plugins/Axios";

const BASE_URL = "ponto-colaboradores";

export class RelatorioPontoService {
  async relatorioDiario(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/relatorio-diario`, { params });
    return response.data;
  }

  async relatorioDiarioPdf(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/pontos/relatorio-diario/pdf`, {
      params,
      responseType: "arraybuffer",
    });
    return this.criarPdfUrl(response.data);
  }

  criarPdfUrl(data) {
    const blob = new Blob([data], { type: "application/pdf" });
    return window.URL.createObjectURL(blob);
  }
}

export default new RelatorioPontoService();
